export const EXTEND_SCRAPER_LOG = 'EXTEND_SCRAPER_LOG';
